<template>
  <span>
    <b-tooltip label="Удалить из группы" class="m-r-sm" v-if="isFavouriteGroup" animated>
      <b-button type="is-text" size="is-small" @click="showRemoveModal()">
        <b-icon custom-size="mdi-18px" icon="trash-can"></b-icon>
      </b-button>
    </b-tooltip>

    <b-tooltip label="Избранное" animated>
      <b-button type="is-text" size="is-small" @click="showAddModal()">
        <b-icon
          custom-size="mdi-18px"
          :type="{ 'is-warning': inFavouriteGroups.length }"
          :icon="inFavouriteGroups.length > 0 ? 'star' : 'star-outline'"
        >
        </b-icon>
      </b-button>
    </b-tooltip>

    <b-modal :active.sync="isRemoveModalShown" scroll="keep" :has-modal-card="true">
      <div class="modal-card" style="width: auto">
        <section class="modal-card-body p-lg">
          <form @submit.prevent="onRemoveSubmit">
            <div class="columns">
              <div class="column">
                <div class="title is-5 m-t-xs">Удалить из текущей группы?</div>
              </div>
            </div>
            <div class="buttons is-centered">
              <b-button @click="isRemoveModalShown = false">Отмена</b-button>
              <b-button type="is-danger" native-type="submit" :loading="loading" :disabled="loading"
                >Да, удалить</b-button
              >
            </div>
          </form>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isAddModalShown" scroll="keep" :has-modal-card="true">
      <div class="modal-card" style="width: 500px;">
        <section class="modal-card-body p-lg">
          <form @submit.prevent="onAddSubmit()">
            <div class="columns">
              <div class="column">
                <div class="title is-5 m-t-xs">Добавить в группу</div>
              </div>
              <div class="column is-narrow">
                <favourite-add-group>
                  <b-button class="is-light">
                    <span class="icon">
                      <i class="mdi mdi-plus-circle-outline"></i>
                    </span>
                    <span>Создать группу</span>
                  </b-button>
                </favourite-add-group>
              </div>
            </div>
            <b-field grouped>
              <b-select
                placeholder="Укажите группу"
                icon="folder-plus"
                v-model="selectedGroupId"
                @input="checkInput"
                expanded
              >
                <option
                  v-for="(favouriteGroup, index) in favouriteGroups"
                  :key="index"
                  :value="favouriteGroup.id"
                  :class="{
                    'has-background-white-ter': !!~inFavouriteGroups.indexOf(favouriteGroup.id),
                    'has-text-grey': !!~inFavouriteGroups.indexOf(favouriteGroup.id)
                  }"
                  >{{ !!~inFavouriteGroups.indexOf(favouriteGroup.id) ? '&#9733;' : '' }}
                  {{ favouriteGroup.name }}</option
                >
              </b-select>
              <span class="control">
                <b-button
                  type="is-primary"
                  native-type="submit"
                  :loading="loading"
                  :disabled="loading || !!~inFavouriteGroups.indexOf(selectedGroupId)"
                  >Добавить</b-button
                >
              </span>
            </b-field>
            <div v-if="error" class="has-text-danger">{{ errorMsg }}</div>
          </form>
        </section>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'FavouriteToggler',
  components: {
    FavouriteAddGroup: () =>
      import(/* webpackChunkName: "FavouriteAddGroup" */ '@/components/user/favourites/FavouriteAddGroup.vue')
  },
  data() {
    return {
      isInGroup: true,
      isAddModalShown: false,
      isRemoveModalShown: false,
      error: false,
      errorMsg: '',
      loading: false,
      selectedGroupId: null
    };
  },
  props: {
    isShort: {
      type: Boolean,
      default: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    groupId: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    ...mapActions('favourites', {
      addFavourite: 'addFavourite',
      removeFavourite: 'removeFavourite'
    }),
    checkInput() {
      this.clearErrors();

      const selectedGroup = this.favouriteGroups.find(el => {
        return el.id === this.selectedGroupId;
      });

      if (
        selectedGroup.favourites.find(el => {
          return el.tableId === this.id;
        })
      ) {
        this.showError('Уже включено в выбранную группу');
      }
    },
    showError(errorMsg) {
      this.error = true;
      this.errorMsg = errorMsg;
    },
    clearErrors() {
      this.error = false;
      this.errorMsg = '';
    },
    showAddModal() {
      this.isAddModalShown = true;
      this.selectedGroupId = null;
      this.loading = false;
      this.clearErrors();
    },
    showRemoveModal() {
      this.isRemoveModalShown = true;
      this.loading = false;
    },
    onRemoveSubmit() {
      this.loading = true;

      const findGroup = this.favouriteGroups.find(group => group.id == this.groupId);
      const findFavourite = findGroup.favourites.find(el => el.tableId == this.id);

      this.removeFavourite({
        id: findFavourite.id,
        favouriteGroupId: findGroup.id
      })
        .then(() => {
          this.loading = false;
          this.isRemoveModalShown = false;
          this.$emit('reload');
          this.toast({
            message: 'Удалено из группы',
            type: 'is-danger'
          });
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          this.errorMsg = `Ошибка. ${error}`;
        });
    },
    onAddSubmit() {
      this.loading = true;
      this.clearErrors();

      if (this.selectedGroupId === null) {
        this.loading = false;
        this.showError('Выберите группу');
        return;
      }

      const selectedGroup = this.favouriteGroups.find(el => {
        return el.id === this.selectedGroupId;
      });

      if (
        selectedGroup.favourites.find(el => {
          return el.tableId === this.id;
        })
      ) {
        this.loading = false;
        this.showError('Объект уже включён в группу');
        return;
      }

      this.addFavourite({
        favouriteGroupId: this.selectedGroupId,
        tableId: this.id
      })
        .then(() => {
          this.loading = false;
          this.groupName = '';
          this.isAddModalShown = false;
          this.toast({
            message: 'Добавлено в группу',
            type: 'is-warning'
          });
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          this.errorMsg = `Ошибка. ${error}`;
        });
    }
  },
  computed: {
    ...mapState({
      favouriteGroups: state => state.favourites.favouriteGroups
    }),

    isFavouriteGroup() {
      return this.groupId !== '';
    },

    inFavouriteGroups() {
      let inGroupIds = [];
      for (const group of this.favouriteGroups) {
        for (const item of group.favourites) {
          // TODO строгая проверка при объявлении типа данных
          if (item.tableId == this.id) {
            inGroupIds.push(item.favouriteGroupId);
          }
        }
      }

      return inGroupIds;
    }
  }
};
</script>

<style lang="scss" scoped></style>
